import { render, staticRenderFns } from "./AwaitingCalls.vue?vue&type=template&id=f03bc660&"
import script from "./AwaitingCalls.vue?vue&type=script&lang=js&"
export * from "./AwaitingCalls.vue?vue&type=script&lang=js&"
import style0 from "./AwaitingCalls.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports